import axios from 'axios';
import config from '@/config/app.config';

const http = axios.create({
  baseURL: config.api_url,
});

class AuthService {
  async login(username, password) {
    const res = await http.post('/api/auth/login', { username, password });
    localStorage.setItem('auth_token', res.data.token);
    localStorage.setItem('auth_username', res.data.username);
    return res.data;
  }

  async register(username, password) {
    const res = await http.post('/api/auth/register', { username, password });
    localStorage.setItem('auth_token', res.data.token);
    localStorage.setItem('auth_username', res.data.username);
    return res.data;
  }

  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_username');
  }

  isLoggedIn() {
    return !!localStorage.getItem('auth_token');
  }

  getUsername() {
    return localStorage.getItem('auth_username');
  }
}

export default new AuthService();
